import React from 'react';

const FoodSafetyCertificate = () => {
  return (
    <div className="my-6 p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-xl border border-green-200 shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="flex items-center justify-center mb-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-4 shadow-md">
          <span className="text-2xl">🛡️</span>
        </div>
        <div>
          <h5 className="text-lg font-bold text-green-800">Food Safety Certified</h5>
          <p className="text-sm text-green-600">Official Certification</p>
        </div>
      </div>
      
      <div className="flex justify-center">
        <div className="relative group">
          <div 
            className="w-48 h-auto cursor-pointer"
            onClick={() => {
              console.log('Certificate container clicked!');
              window.open('/assets/logo/food-safety-cert.png', '_blank');
            }}
          >
            <img 
              src="/assets/logo/food-safety-cert.png" 
              alt="Food Safety Certificate" 
              className="w-full h-auto object-contain rounded-lg shadow-md hover:scale-105 transition-transform duration-300 border-2 border-green-200"
              title="Click to view full certificate"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          </div>
          
          <div 
            className="w-48 h-32 bg-green-100 rounded-lg shadow-md border-2 border-green-200 hidden items-center justify-center"
            style={{ display: 'none' }}
          >
            <div className="text-center">
              <span className="text-4xl mb-2 block">🛡️</span>
              <p className="text-sm text-green-700 font-semibold">Certificate</p>
            </div>
          </div>
          
          
        </div>
      </div>
      
      <div className="text-center mt-3">
        <button 
          onClick={() => {
            console.log('View certificate button clicked!');
            window.open('/assets/logo/food-safety-cert.png', '_blank');
          }}
          className="inline-flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg"
        >
          <span>View Full Certificate</span>
        </button>
      </div>
      
      <div className="mt-4 text-center">
        <div className="inline-flex items-center space-x-2 bg-green-100 px-3 py-1 rounded-full">
          <span className="text-green-600 text-sm">✓</span>
          <span className="text-green-700 text-xs font-medium">Verified & Certified</span>
        </div>
      </div>
    </div>
  );
};

export default FoodSafetyCertificate; 